
import React, { Component } from 'react';
import { Alert } from 'reactstrap';
import { ArcaCalendar } from '../../code/Types/ArcaCalendar';
import { ArcaDate } from '../../code/Types/ArcaDate';
import { ArcaTimeslot } from '../../code/ArcaTimeslot';

export class UnitTestArcaTimeslot extends Component {
    constructor(props) {
        super(props);
        this.state = {
            usefulText: null
        };
    }

    componentDidMount() {
        this.ArcaTimeslot_DoubleSlotRewrites_Test();
        this.ArcaTimeslot_NewSlotAdds_Test();
    }

    ArcaTimeslot_DoubleSlotRewrites_Test() {
        var slot = new ArcaTimeslot(
            'Midday',
            new ArcaDate((new Date("2020-5-6")).getTime()),
            true);

        var arcaCalendar = new ArcaCalendar();
        arcaCalendar.AddTimeslot(slot);
        slot.Selected = false;
        arcaCalendar.AddTimeslot(slot);

        var resultSlot = arcaCalendar.Slots[slot.Key];

        var result = Object.keys(arcaCalendar.Slots).length === 1
            && !resultSlot.Selected
            && resultSlot.Slotname === 'Midday';

        this.setState({
            ArcaTimeslotDoubleSlotRewritesTestOk: result,
            usefulText: result ? 'OK' : resultSlot.Key
        });
    }

    ArcaTimeslot_NewSlotAdds_Test() {
        var slot = new ArcaTimeslot(
            'Midday',
            new ArcaDate((new Date("2020-5-6")).getTime()),
            true);

        var slot2 = new ArcaTimeslot(
            'AM',
            new ArcaDate((new Date("2020-5-6")).getTime()),
            false);

        var arcaCalendar = new ArcaCalendar();
        arcaCalendar.AddTimeslot(slot);
        arcaCalendar.AddTimeslot(slot2);

        var resultSlot = arcaCalendar.Slots[slot.Key];
        var resultSlot2 = arcaCalendar.Slots[slot2.Key];

        var result = Object.keys(arcaCalendar.Slots).length === 2
            && resultSlot.Selected
            && !resultSlot2.Selected
            && resultSlot2.Slotname === 'AM'
            && resultSlot.Slotname === 'Midday';

        this.setState({
            ArcaTimeslotNewSlotAddsTestOk: result,
            usefulText: result ? 'OK' : Object.keys(arcaCalendar.Slots).length
        });
    }


    /*eslint-disable */
    render() {
        return (
            <div>
                <Alert color="secondary">
                    {this.state.usefulText
                        ? <div>{this.state.usefulText}</div>
                        : "blank"}
                </Alert>
                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead>
                        <tr>
                            <th>ArcaDate</th>
                            <th>Result</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>ArcaTimeslot_DoubleSlotRewrites_Test</td>
                            {this.state.ArcaTimeslotDoubleSlotRewritesTestOk
                                ? <td>OK</td>
                                : <td>Broke</td>}
                        </tr>
                        <tr>
                            <td>ArcaTimeslot_NewSlotAdds_Test</td>
                            {this.state.ArcaTimeslotNewSlotAddsTestOk
                                ? <td>OK</td>
                                : <td>Broke</td>}
                        </tr>
                    </tbody>
                </table>
            </div >
        );
    }
}
